import { render, staticRenderFns } from "./Perks.vue?vue&type=template&id=1184f0b6&scoped=true&"
import script from "./Perks.vue?vue&type=script&lang=js&"
export * from "./Perks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184f0b6",
  null
  
)

export default component.exports